module.exports = __webpack_public_path__ + "img/infernal_tank_small.05749c66.png";